import { ActionCard } from '@playbooks/core/src/interfaces/ActionCard'

import { instance as funnelViewOpenedSeparatorsDbStore } from './funnelViewOpenedSeparatorsDbStore'

let _track: (event: string, data: Record<string, unknown>) => void = () => {}

export function setTrackFunction(trackFn: (event: string, data: Record<string, unknown>) => void) {
  _track = trackFn
}

export function trackLastActiveSeparatorChanged(
  playbookId: string,
  actionCard: ActionCard,
  oldActionCard: ActionCard | null,
) {
  if (
    !actionCard.lastActiveSeparator ||
    actionCard.lastActiveSeparator <= 0 ||
    // if user clears some header-section, we make previous active header-section as lastActiveSeparator
    // but it doesn't mean that user has started editing of the section and we shouldn't track this change
    // so log scope's only if previous version of AC hasn't contain the separator among enabled
    (oldActionCard?.enabledSeparators?.some((x: number) => x == actionCard.lastActiveSeparator) ?? false)
  ) {
    return
  }

  _track('ac_activeScopeChanged', {
    playbookId: playbookId,
    lastActiveSeparator: actionCard.lastActiveSeparator,
  })
}

export async function trackFunnelViewSlideChanged(playbookId: string, openedSlideSeparatorId: number) {
  if (!openedSlideSeparatorId || openedSlideSeparatorId <= 0) {
    return
  }

  let openedSeparatorIds = await funnelViewOpenedSeparatorsDbStore.get(playbookId)

  if (!openedSeparatorIds) {
    openedSeparatorIds = []
  }
  if (openedSeparatorIds.indexOf(openedSlideSeparatorId) > -1) {
    return
  }
  openedSeparatorIds.push(openedSlideSeparatorId)
  await funnelViewOpenedSeparatorsDbStore.save(playbookId, openedSeparatorIds)
  _track('ac_activeScopeChanged', {
    playbookId: playbookId,
    lastActiveSeparator: openedSlideSeparatorId,
  })
}

export function trackSubmitted(playbookId: string, keywords: string[]) {
  const eventData = {
    playbookId: playbookId,
    keywords: keywords,
  }
  addUTMParams(eventData)
  _track('ac_submitted', eventData)
}

export function trackRequested(playbookId: string) {
  _track('ac_requested', { playbookId })
}

function addUTMParams(eventData: Record<string, unknown>) {
  const params = new URLSearchParams(window.location.search)
  const utmKeys = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_term', 'utm_content']

  for (const key of utmKeys) {
    const value = params.get(key)
    if (value) {
      eventData[key] = value
    }
  }
  return eventData
}
